export default "/SiteCollectionImages/react-apps/nykredit/src/images/_NJ05504.jpg";